import React, { useCallback, useState } from 'react'
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline'
import { CustomFilledButton } from '../../common/buttons/CustomFilledButton'
import { centsClient } from '../../../../api/cents/clients/cents-client'

interface Props {
  label: string
  contractId: string
}

const PdfDownloadComponent: React.FC<Props> = ({ label, contractId }) => {
  const [loading, setLoading] = useState(false)
  /**
   * Temporary fix for downloading the contract in an authenticated way
   */
  const handleOpen = useCallback(async () => {
    setLoading(true)
    try {
      const blob = await centsClient.contracts.getPdf(contractId)
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `contratto-${contractId}.pdf`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      // Revoke the object URL after download to free memory
      URL.revokeObjectURL(url)
    } finally {
      setLoading(false)
    }
  }, [contractId])

  return (
    <div className="w-full h-fit flex justify-end">
      <CustomFilledButton onClick={handleOpen} className="gap-3" loading={loading} disabled={loading}>
        <DocumentArrowDownIcon className="w-4 h-auto" />
        {label}
      </CustomFilledButton>
    </div>
  )
}

export default PdfDownloadComponent
